import "./App.css";
import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import Contact from "./components/Contact";

function App() {
  const [cart, setCart] = useState([]);

  const addToCart = (item) => {
    setCart([...cart, item]);
  };

  return (
    <div id="top">
      <Navbar cartCount={cart.length} />
      <Hero />
      <Menu addToCart={addToCart} />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;